<template>
  <v-list-item two-line v-if="users">
    <v-list-item-content>
      <v-list-item-title>{{users_name}}</v-list-item-title>
      <v-list-item-subtitle>{{created_at}}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-row>
        <v-btn
          v-if="!verified_at"
          rounded
          text
          small
          color="success"
          @click="$emit('verify', uuid)"
        >
          Verify
          <v-icon right>mdi-check</v-icon>
        </v-btn>
        <v-btn v-else rounded text small color="red" @click="$emit('reject', uuid)">
          reject
          <v-icon right>mdi-minus</v-icon>
        </v-btn>
        <v-btn rounded text small @click="$emit('show', uuid)">
          show
          <v-icon right>mdi-open-in-new</v-icon>
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small color="primary" text v-on="on">
              Users
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="user in this.users" :key="user.uuid">
              <user-block @show="showUser" :user="user" />
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import UserBlock from "./UserBlock";
export default {
  props: ["uuid", "created_at", "users", "verified_at"],
  components: {
    "user-block": UserBlock
  },
  computed: {
    users_name() {
      let result = "";
      this.users.forEach((user, index) => {
        let name = user.first_name + " " + user.last_name;
        if (index % 2 != 0) name = " - " + name;
        result += name;
      });
      return result;
    }
  },
  methods: {
    showUser(uuid) {
      this.$router.push({
        name: "users.show",
        params: { uuid }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
